<template>
  <modal
      name="campoAdicionalSql"
      height="auto"
      width="800"
      :scrollable="true"
      :clickToClose="false"
  >
  <CloseModal :close="closeModal" />
    <div class="modalbox">
      <div class="modalbox-content">
        <CCard>
          <CCardBody>
            <div class="row">
              <div class="col">
                <div class="form-group">
                    <h4>Query a ser executada</h4>
                </div>
                <div class="row">
                  <div class="form-group col-6">
                      <label>Local de execução da Query</label>
                      <select class="form-control" v-model="campoEditado.banco_opcao">
                          <option value="LOCAL">Banco de dados Versotech</option>
                          <option value="ERP">Banco de dados ERP</option>
                      </select>
                  </div>
                </div>

                <div class="codemirror">
                  <codemirror ref="cmEditor" v-model="campoEditado.query" :options="code_options"></codemirror>
                </div>

                <div class="variaveis-painel mt-3">
                  <div class="variaveis-header" @click="painelAberto = !painelAberto">
                    <div class="d-flex align-items-center justify-content-between">
                      <div>
                        <fa-icon :icon="painelAberto ? 'chevron-down' : 'chevron-right'" class="mr-2" />
                        <strong>Variáveis disponíveis</strong>
                        <small class="text-muted ml-2">Clique para inserir no editor</small>
                      </div>
                    </div>
                  </div>
                  <div v-show="painelAberto" class="variaveis-body">
                    <input
                      type="text"
                      class="form-control form-control-sm mb-2"
                      placeholder="Buscar variável..."
                      v-model="buscaVariavel"
                      @click.stop
                    />
                    <div v-if="loadingVariaveis" class="text-center py-2">
                      <small class="text-muted">Carregando...</small>
                    </div>
                    <div v-else v-for="(grupo, chave) in variaveisFiltradas" :key="chave" class="variaveis-grupo">
                      <div class="variaveis-grupo-titulo" @click.stop="toggleGrupo(chave)">
                        <fa-icon :icon="gruposAbertos[chave] ? 'chevron-down' : 'chevron-right'" class="mr-1" />
                        <small><strong>{{ grupo.titulo }}</strong></small>
                        <small class="text-muted ml-1">— {{ grupo.descricao }}</small>
                      </div>
                      <div v-show="gruposAbertos[chave]" class="variaveis-chips">
                        <span
                          v-for="variavel in grupo.variaveis"
                          :key="variavel.nome"
                          class="variavel-chip"
                          :title="variavel.descricao"
                          @click.stop="inserirVariavel(variavel.nome)"
                        >
                          {{ variavel.nome }}
                        </span>
                      </div>
                    </div>
                    <div v-if="!loadingVariaveis && Object.keys(variaveisFiltradas).length === 0" class="text-center py-2">
                      <small class="text-muted">Nenhuma variável encontrada</small>
                    </div>
                  </div>
                </div>

                <div><br>
                    <h5>Atenção</h5>
                    <small>
                      Este campo é utilizado preenchimento de opções a serem listadas quando o parâmetro é dos tipos: <strong>"SELECT", "CHECKBOX", "MULTISELECT" e "RADIO"</strong>.
                      Para utilização do formato SQL, nota-se que estas consultas são executadas utilizando o banco de dados da Versotech ou banco de dados ERP,
                      ao executar uma consulta SQL, deve-se retornar 2 aliases de nome <strong>"chave" e "valor"</strong>, o campo informado pela <strong>"chave"</strong> será o
                      utilizado para envio no parâmetro, enquanto que <strong>"valor"</strong> será apenas para exibição.
                      Use sempre um identificador único e estável como <strong>"chave"</strong> (ex: <code>id</code>), nunca a descrição — assim, se o texto mudar na tabela fonte, o valor salvo permanece válido.
                    </small><br><br>
                    <small>
                      <strong>Variáveis dinâmicas:</strong> utilize as variáveis do painel acima para tornar a query contextual.
                      Variáveis de <strong>usuário autenticado</strong> (<code>:AUTH_*</code>), <strong>data</strong> (<code>:DATE_*</code>) e <strong>parâmetros do sistema</strong> (<code>:PARAM_*</code>) são resolvidas automaticamente.
                      <span v-if="entidade === 'orcamento'">
                        Variáveis de <strong>orçamento</strong> (<code>:ORCAMENTO_*</code>) são resolvidas com base no orçamento em andamento, permitindo filtrar as opções pelo cliente, representante, operação, etc.
                      </span>
                      <span v-if="campoEditado.banco_opcao === 'ERP'">
                        Variáveis de <strong>views do ERP</strong> (<code>:V_BDTI_*</code>, <code>:V_VERSOTECH_*</code>) inserem subqueries das views cadastradas no sistema diretamente na consulta.
                      </span>
                      Variáveis não resolvidas no momento da execução são removidas automaticamente da query, sem causar erro.
                    </small><br><br>
                    <small><strong>⚠️ Cuidado, a consulta deve ser feita pensando em sua performance no geral, grandes consultas ocasionarão lentidão no sistema.</strong></small>
                </div>
        </div>
            </div>
          </CCardBody>
        </CCard>
      </div>
      <div class="modal-footer">
        <button
            class="button-success button w-25 float-right"
            v-on:click="onSubmit"
        >
          Salvar
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
import CloseModal from "../../../components/CloseModal";
import { codemirror } from 'vue-codemirror'
import { get } from '../../../helpers/apiRequest'

export default {
  emits: ['update:campoEditado'],
  name: "CampoAdicionalSql",
  props: ["campoEditado", "entidade"],
  data() {
    return {
      code_options: {
        tabSize: 4,
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        mode: 'text/x-sql',
        autoRefresh: true,
        lineWrapping: true,
        theme: 'monokai',
        showCursorWhenSelecting: true,
        highlightSelectionMatches: {
          showToken: /\w/,
          annotateScrollbar: true
        },
      },
      variaveis: {},
      loadingVariaveis: false,
      buscaVariavel: '',
      gruposAbertos: {},
      painelAberto: true,
    }
  },
  components: {
    codemirror,
    CloseModal,
  },
  computed: {
    variaveisDisponiveis() {
      const filtradas = {};

      for (const [chave, grupo] of Object.entries(this.variaveis)) {
        const restricao = grupo.restrito_a || {};

        if (restricao.entidade && restricao.entidade !== this.entidade) continue;
        if (restricao.banco_opcao && restricao.banco_opcao !== this.campoEditado.banco_opcao) continue;

        filtradas[chave] = grupo;
      }

      return filtradas;
    },
    variaveisFiltradas() {
      const busca = this.buscaVariavel.toLowerCase().trim();
      if (!busca) return this.variaveisDisponiveis;

      const filtradas = {};
      for (const [chave, grupo] of Object.entries(this.variaveisDisponiveis)) {
        const vars = grupo.variaveis.filter(v =>
          v.nome.toLowerCase().includes(busca) ||
          v.descricao.toLowerCase().includes(busca)
        );
        if (vars.length) {
          filtradas[chave] = { ...grupo, variaveis: vars };
        }
      }
      return filtradas;
    },
  },
  methods: {
    closeModal() {
      this.$modal.hide("campoAdicionalSql");
    },
    onSubmit() {
      this.campoEditado.campo_adicional_opcoes = [];
      this.closeModal();
    },
    loadVariaveis() {
      this.loadingVariaveis = true;
      get('/admin/variaveis-campos-adicionais')
        .then((response) => {
          this.variaveis = response.data;
          for (const chave of Object.keys(response.data)) {
            this.$set(this.gruposAbertos, chave, true);
          }
        })
        .finally(() => {
          this.loadingVariaveis = false;
        });
    },
    toggleGrupo(chave) {
      this.$set(this.gruposAbertos, chave, !this.gruposAbertos[chave]);
    },
    inserirVariavel(nome) {
      const cm = this.$refs.cmEditor?.codemirror;
      if (cm) {
        cm.focus();
        cm.replaceSelection(nome);
      }
    },
  },
  beforeMount() {
    this.loadVariaveis();
  },
};
</script>

<style scoped>
.variaveis-painel {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  overflow: hidden;
}

.variaveis-header {
  padding: 8px 12px;
  background: #f8f9fa;
  cursor: pointer;
  user-select: none;
  border-bottom: 1px solid #dee2e6;
}

.variaveis-header:hover {
  background: #e9ecef;
}

.variaveis-body {
  padding: 10px 12px;
  max-height: 280px;
  overflow-y: auto;
}

.variaveis-grupo {
  margin-bottom: 6px;
}

.variaveis-grupo-titulo {
  cursor: pointer;
  padding: 3px 0;
  user-select: none;
}

.variaveis-grupo-titulo:hover {
  color: #321fdb;
}

.variaveis-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  padding: 4px 0 4px 16px;
}

.variavel-chip {
  display: inline-block;
  padding: 2px 8px;
  font-size: 11.5px;
  font-family: monospace;
  font-weight: 600;
  color: #321fdb;
  background: #eef2ff;
  border: 1px solid #c7d2fe;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.15s;
  user-select: none;
}

.variavel-chip:hover {
  background: #321fdb;
  color: #fff;
  border-color: #321fdb;
}
</style>
